// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"29c1b567","123":"4957270e","210":"2a3ceb94","272":"20b17b84","600":"a9a1761a"}[chunkId] + ".chunk.css";
};